module.exports = __webpack_public_path__ + "img/main_media_slide5.33b7514a.jpg";